module.exports = __webpack_public_path__ + "media/images/gallery/constellations/leo/leo_minor_vis-fe3b85efe42f5c6fdc17da6e7aa2ef02.jpg";